import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { browserPerformanceTimeOrigin, spanToJSON, setMeasurement, getActiveSpan, parseUrl, stringMatchesSomePattern, isPrimitive, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, htmlTreeAsString, getComponentName } from '@sentry/core';
import { WINDOW } from '../types.js';
import { trackClsAsStandaloneSpan } from './cls.js';
import { addPerformanceInstrumentationHandler, addLcpInstrumentationHandler, addTtfbInstrumentationHandler, addClsInstrumentationHandler } from './instrument.js';
import { trackLcpAsStandaloneSpan } from './lcp.js';
import { resourceTimingToSpanAttributes } from './resourceTiming.js';
import { getBrowserPerformanceAPI, msToSec, startAndEndSpan, isMeasurementValue } from './utils.js';
import { getActivationStart } from './web-vitals/lib/getActivationStart.js';
import { getNavigationEntry } from './web-vitals/lib/getNavigationEntry.js';
import { getVisibilityWatcher } from './web-vitals/lib/getVisibilityWatcher.js';
var MAX_INT_AS_BYTES = 2147483647;
var _performanceCursor = 0;
var _measurements = {};
var _lcpEntry;
var _clsEntry;

/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */
function startTrackingWebVitals(_ref) {
  var recordClsStandaloneSpans = _ref.recordClsStandaloneSpans,
    recordLcpStandaloneSpans = _ref.recordLcpStandaloneSpans,
    client = _ref.client;
  var performance = getBrowserPerformanceAPI();
  if (performance && browserPerformanceTimeOrigin()) {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    if (performance.mark) {
      WINDOW.performance.mark('sentry-tracing-init');
    }
    var lcpCleanupCallback = recordLcpStandaloneSpans ? trackLcpAsStandaloneSpan(client) : _trackLCP();
    var ttfbCleanupCallback = _trackTtfb();
    var clsCleanupCallback = recordClsStandaloneSpans ? trackClsAsStandaloneSpan(client) : _trackCLS();
    return function () {
      lcpCleanupCallback === null || lcpCleanupCallback === void 0 || lcpCleanupCallback();
      ttfbCleanupCallback();
      clsCleanupCallback === null || clsCleanupCallback === void 0 || clsCleanupCallback();
    };
  }
  return function () {
    return undefined;
  };
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  addPerformanceInstrumentationHandler('longtask', function (_ref2) {
    var entries = _ref2.entries;
    var parent = getActiveSpan();
    if (!parent) {
      return;
    }
    var _spanToJSON = spanToJSON(parent),
      parentOp = _spanToJSON.op,
      parentStartTimestamp = _spanToJSON.start_timestamp;
    var _iterator = _createForOfIteratorHelper(entries),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;
        var startTime = msToSec(browserPerformanceTimeOrigin() + entry.startTime);
        var duration = msToSec(entry.duration);
        if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) {
          // Skip adding a span if the long task started before the navigation started.
          // `startAndEndSpan` will otherwise adjust the parent's start time to the span's start
          // time, potentially skewing the duration of the actual navigation as reported via our
          // routing instrumentations
          continue;
        }
        startAndEndSpan(parent, startTime, startTime + duration, {
          name: 'Main UI thread blocked',
          op: 'ui.long-task',
          attributes: _defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.ui.browser.metrics')
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
}

/**
 * Start tracking long animation frames.
 */
function startTrackingLongAnimationFrames() {
  // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
  // we directly observe `long-animation-frame` events instead of through the web-vitals
  // `observe` helper function.
  var observer = new PerformanceObserver(function (list) {
    var parent = getActiveSpan();
    if (!parent) {
      return;
    }
    var _iterator2 = _createForOfIteratorHelper(list.getEntries()),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var entry = _step2.value;
        if (!entry.scripts[0]) {
          continue;
        }
        var startTime = msToSec(browserPerformanceTimeOrigin() + entry.startTime);
        var _spanToJSON2 = spanToJSON(parent),
          parentStartTimestamp = _spanToJSON2.start_timestamp,
          parentOp = _spanToJSON2.op;
        if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) {
          // Skip adding the span if the long animation frame started before the navigation started.
          // `startAndEndSpan` will otherwise adjust the parent's start time to the span's start
          // time, potentially skewing the duration of the actual navigation as reported via our
          // routing instrumentations
          continue;
        }
        var duration = msToSec(entry.duration);
        var attributes = _defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.ui.browser.metrics');
        var initialScript = entry.scripts[0];
        var invoker = initialScript.invoker,
          invokerType = initialScript.invokerType,
          sourceURL = initialScript.sourceURL,
          sourceFunctionName = initialScript.sourceFunctionName,
          sourceCharPosition = initialScript.sourceCharPosition;
        attributes['browser.script.invoker'] = invoker;
        attributes['browser.script.invoker_type'] = invokerType;
        if (sourceURL) {
          attributes['code.filepath'] = sourceURL;
        }
        if (sourceFunctionName) {
          attributes['code.function'] = sourceFunctionName;
        }
        if (sourceCharPosition !== -1) {
          attributes['browser.script.source_char_position'] = sourceCharPosition;
        }
        startAndEndSpan(parent, startTime, startTime + duration, {
          name: 'Main UI thread blocked',
          op: 'ui.long-animation-frame',
          attributes: attributes
        });
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  });
  observer.observe({
    type: 'long-animation-frame',
    buffered: true
  });
}

/**
 * Start tracking interaction events.
 */
function startTrackingInteractions() {
  addPerformanceInstrumentationHandler('event', function (_ref3) {
    var entries = _ref3.entries;
    var parent = getActiveSpan();
    if (!parent) {
      return;
    }
    var _iterator3 = _createForOfIteratorHelper(entries),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var entry = _step3.value;
        if (entry.name === 'click') {
          var startTime = msToSec(browserPerformanceTimeOrigin() + entry.startTime);
          var duration = msToSec(entry.duration);
          var spanOptions = {
            name: htmlTreeAsString(entry.target),
            op: "ui.interaction.".concat(entry.name),
            startTime: startTime,
            attributes: _defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.ui.browser.metrics')
          };
          var componentName = getComponentName(entry.target);
          if (componentName) {
            spanOptions.attributes['ui.component_name'] = componentName;
          }
          startAndEndSpan(parent, startTime, startTime + duration, spanOptions);
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  });
}

/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */
function _trackCLS() {
  return addClsInstrumentationHandler(function (_ref4) {
    var metric = _ref4.metric;
    var entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }
    _measurements['cls'] = {
      value: metric.value,
      unit: ''
    };
    _clsEntry = entry;
  }, true);
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  return addLcpInstrumentationHandler(function (_ref5) {
    var metric = _ref5.metric;
    var entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }
    _measurements['lcp'] = {
      value: metric.value,
      unit: 'millisecond'
    };
    _lcpEntry = entry;
  }, true);
}
function _trackTtfb() {
  return addTtfbInstrumentationHandler(function (_ref6) {
    var metric = _ref6.metric;
    var entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }
    _measurements['ttfb'] = {
      value: metric.value,
      unit: 'millisecond'
    };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(span, options) {
  var performance = getBrowserPerformanceAPI();
  var origin = browserPerformanceTimeOrigin();
  if (!(performance !== null && performance !== void 0 && performance.getEntries) || !origin) {
    // Gatekeeper if performance API not available
    return;
  }
  var timeOrigin = msToSec(origin);
  var performanceEntries = performance.getEntries();
  var _spanToJSON3 = spanToJSON(span),
    op = _spanToJSON3.op,
    transactionStartTime = _spanToJSON3.start_timestamp;
  performanceEntries.slice(_performanceCursor).forEach(function (entry) {
    var startTime = msToSec(entry.startTime);
    var duration = msToSec(
    // Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
    // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
    // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
    // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
    Math.max(0, entry.duration));
    if (op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) {
      return;
    }
    switch (entry.entryType) {
      case 'navigation':
        {
          _addNavigationSpans(span, entry, timeOrigin);
          break;
        }
      case 'mark':
      case 'paint':
      case 'measure':
        {
          _addMeasureSpans(span, entry, startTime, duration, timeOrigin, options.ignorePerformanceApiSpans);

          // capture web vitals
          var firstHidden = getVisibilityWatcher();
          // Only report if the page wasn't hidden prior to the web vital.
          var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
          if (entry.name === 'first-paint' && shouldRecord) {
            _measurements['fp'] = {
              value: entry.startTime,
              unit: 'millisecond'
            };
          }
          if (entry.name === 'first-contentful-paint' && shouldRecord) {
            _measurements['fcp'] = {
              value: entry.startTime,
              unit: 'millisecond'
            };
          }
          break;
        }
      case 'resource':
        {
          _addResourceSpans(span, entry, entry.name, startTime, duration, timeOrigin, options.ignoreResourceSpans);
          break;
        }
      // Ignore other entry types.
    }
  });
  _performanceCursor = Math.max(performanceEntries.length - 1, 0);
  _trackNavigator(span);

  // Measurements are only available for pageload transactions
  if (op === 'pageload') {
    _addTtfbRequestTimeToMeasurements(_measurements);

    // If CLS standalone spans are enabled, don't record CLS as a measurement
    if (!options.recordClsOnPageloadSpan) {
      delete _measurements.cls;
    }

    // If LCP standalone spans are enabled, don't record LCP as a measurement
    if (!options.recordLcpOnPageloadSpan) {
      delete _measurements.lcp;
    }
    Object.entries(_measurements).forEach(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
        measurementName = _ref8[0],
        measurement = _ref8[1];
      setMeasurement(measurementName, measurement.value, measurement.unit);
    });

    // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
    span.setAttribute('performance.timeOrigin', timeOrigin);

    // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
    // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
    // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
    // time where the user actively started the navigation, for example by clicking a link.
    // This is user action is called "activation" and the time between navigation and activation is stored in
    // the `activationStart` attribute of the "navigation" PerformanceEntry.
    span.setAttribute('performance.activationStart', getActivationStart());
    _setWebVitalAttributes(span, options);
  }
  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/**
 * Create measure related spans.
 * Exported only for tests.
 */
function _addMeasureSpans(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
  if (['mark', 'measure'].includes(entry.entryType) && stringMatchesSomePattern(entry.name, ignorePerformanceApiSpans)) {
    return;
  }
  var navEntry = getNavigationEntry(false);
  var requestTime = msToSec(navEntry ? navEntry.requestStart : 0);
  // Because performance.measure accepts arbitrary timestamps it can produce
  // spans that happen before the browser even makes a request for the page.
  //
  // An example of this is the automatically generated Next.js-before-hydration
  // spans created by the Next.js framework.
  //
  // To prevent this we will pin the start timestamp to the request start time
  // This does make duration inaccurate, so if this does happen, we will add
  // an attribute to the span
  var measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
  var startTimeStamp = timeOrigin + startTime;
  var measureEndTimestamp = startTimeStamp + duration;
  var attributes = _defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.resource.browser.metrics');
  if (measureStartTimestamp !== startTimeStamp) {
    attributes['sentry.browser.measure_happened_before_request'] = true;
    attributes['sentry.browser.measure_start_time'] = measureStartTimestamp;
  }
  _addDetailToSpanAttributes(attributes, entry);

  // Measurements from third parties can be off, which would create invalid spans, dropping transactions in the process.
  if (measureStartTimestamp <= measureEndTimestamp) {
    startAndEndSpan(span, measureStartTimestamp, measureEndTimestamp, {
      name: entry.name,
      op: entry.entryType,
      attributes: attributes
    });
  }
}
function _addDetailToSpanAttributes(attributes, performanceMeasure) {
  try {
    // Accessing detail might throw in some browsers (e.g., Firefox) due to security restrictions
    var detail = performanceMeasure.detail;
    if (!detail) {
      return;
    }

    // Process detail based on its type
    if (typeof detail === 'object') {
      // Handle object details
      for (var _i = 0, _Object$entries = Object.entries(detail); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (value && isPrimitive(value)) {
          attributes["sentry.browser.measure.detail.".concat(key)] = value;
        } else if (value !== undefined) {
          try {
            // This is user defined so we can't guarantee it's serializable
            attributes["sentry.browser.measure.detail.".concat(key)] = JSON.stringify(value);
          } catch (_unused) {
            // Skip values that can't be stringified
          }
        }
      }
      return;
    }
    if (isPrimitive(detail)) {
      // Handle primitive details
      attributes['sentry.browser.measure.detail'] = detail;
      return;
    }
    try {
      attributes['sentry.browser.measure.detail'] = JSON.stringify(detail);
    } catch (_unused2) {
      // Skip if stringification fails
    }
  } catch (_unused3) {
    // Silently ignore any errors when accessing detail
    // This handles the Firefox "Permission denied to access object" error
  }
}

/**
 * Instrument navigation entries
 * exported only for tests
 */
function _addNavigationSpans(span, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(function (event) {
    _addPerformanceNavigationTiming(span, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(span, entry, 'secureConnection', timeOrigin, 'TLS/SSL');
  _addPerformanceNavigationTiming(span, entry, 'fetch', timeOrigin, 'cache');
  _addPerformanceNavigationTiming(span, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(span, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(span, entry, event, timeOrigin) {
  var name = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : event;
  var eventEnd = _getEndPropertyNameForNavigationTiming(event);
  var end = entry[eventEnd];
  var start = entry["".concat(event, "Start")];
  if (!start || !end) {
    return;
  }
  startAndEndSpan(span, timeOrigin + msToSec(start), timeOrigin + msToSec(end), {
    op: "browser.".concat(name),
    name: entry.name,
    attributes: _objectSpread(_defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.ui.browser.metrics'), event === 'redirect' && entry.redirectCount != null ? {
      'http.redirect_count': entry.redirectCount
    } : {})
  });
}
function _getEndPropertyNameForNavigationTiming(event) {
  if (event === 'secureConnection') {
    return 'connectEnd';
  }
  if (event === 'fetch') {
    return 'domainLookupStart';
  }
  return "".concat(event, "End");
}

/** Create request and response related spans */
function _addRequest(span, entry, timeOrigin) {
  var requestStartTimestamp = timeOrigin + msToSec(entry.requestStart);
  var responseEndTimestamp = timeOrigin + msToSec(entry.responseEnd);
  var responseStartTimestamp = timeOrigin + msToSec(entry.responseStart);
  if (entry.responseEnd) {
    // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
    // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
    // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
    // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
    startAndEndSpan(span, requestStartTimestamp, responseEndTimestamp, {
      op: 'browser.request',
      name: entry.name,
      attributes: _defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.ui.browser.metrics')
    });
    startAndEndSpan(span, responseStartTimestamp, responseEndTimestamp, {
      op: 'browser.response',
      name: entry.name,
      attributes: _defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.ui.browser.metrics')
    });
  }
}

/**
 * Create resource-related spans.
 * Exported only for tests.
 */
function _addResourceSpans(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }
  var op = entry.initiatorType ? "resource.".concat(entry.initiatorType) : 'resource.other';
  if (ignoredResourceSpanOps !== null && ignoredResourceSpanOps !== void 0 && ignoredResourceSpanOps.includes(op)) {
    return;
  }
  var attributes = _defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.resource.browser.metrics');
  var parsedUrl = parseUrl(resourceUrl);
  if (parsedUrl.protocol) {
    attributes['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
  }
  if (parsedUrl.host) {
    attributes['server.address'] = parsedUrl.host;
  }
  attributes['url.same_origin'] = resourceUrl.includes(WINDOW.location.origin);
  _setResourceRequestAttributes(entry, attributes, [
  // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
  ['responseStatus', 'http.response.status_code'], ['transferSize', 'http.response_transfer_size'], ['encodedBodySize', 'http.response_content_length'], ['decodedBodySize', 'http.decoded_response_content_length'],
  // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
  ['renderBlockingStatus', 'resource.render_blocking_status'],
  // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
  ['deliveryType', 'http.response_delivery_type']]);
  var attributesWithResourceTiming = _objectSpread(_objectSpread({}, attributes), resourceTimingToSpanAttributes(entry));
  var startTimestamp = timeOrigin + startTime;
  var endTimestamp = startTimestamp + duration;
  startAndEndSpan(span, startTimestamp, endTimestamp, {
    name: resourceUrl.replace(WINDOW.location.origin, ''),
    op: op,
    attributes: attributesWithResourceTiming
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(span) {
  var navigator = WINDOW.navigator;
  if (!navigator) {
    return;
  }

  // track network connectivity
  var connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      span.setAttribute('effectiveConnectionType', connection.effectiveType);
    }
    if (connection.type) {
      span.setAttribute('connectionType', connection.type);
    }
    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = {
        value: connection.rtt,
        unit: 'millisecond'
      };
    }
  }
  if (isMeasurementValue(navigator.deviceMemory)) {
    span.setAttribute('deviceMemory', "".concat(navigator.deviceMemory, " GB"));
  }
  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    span.setAttribute('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to span to allow debugging */
function _setWebVitalAttributes(span, options) {
  var _clsEntry2;
  // Only add LCP attributes if LCP is being recorded on the pageload span
  if (_lcpEntry && options.recordLcpOnPageloadSpan) {
    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      span.setAttribute('lcp.element', htmlTreeAsString(_lcpEntry.element));
    }
    if (_lcpEntry.id) {
      span.setAttribute('lcp.id', _lcpEntry.id);
    }
    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      span.setAttribute('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }
    if (_lcpEntry.loadTime != null) {
      // loadTime is the time of LCP that's related to receiving the LCP element response..
      span.setAttribute('lcp.loadTime', _lcpEntry.loadTime);
    }
    if (_lcpEntry.renderTime != null) {
      // renderTime is loadTime + rendering time
      // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
      // `Timing-Allow-Origin` header.
      span.setAttribute('lcp.renderTime', _lcpEntry.renderTime);
    }
    span.setAttribute('lcp.size', _lcpEntry.size);
  }

  // Only add CLS attributes if CLS is being recorded on the pageload span
  if ((_clsEntry2 = _clsEntry) !== null && _clsEntry2 !== void 0 && _clsEntry2.sources && options.recordClsOnPageloadSpan) {
    _clsEntry.sources.forEach(function (source, index) {
      return span.setAttribute("cls.source.".concat(index + 1), htmlTreeAsString(source.node));
    });
  }
}

/**
 * Use this to set any attributes we can take directly form the PerformanceResourceTiming entry.
 *
 * This is just a mapping function for entry->attribute to keep bundle-size minimal.
 * Experimental properties are also accepted (see {@link ExperimentalResourceTimingProperty}).
 * Assumes that all entry properties might be undefined for browser-specific differences.
 * Only accepts string and number values for now and also sets 0-values.
 */
function _setResourceRequestAttributes(entry, attributes, properties) {
  properties.forEach(function (_ref9) {
    var _ref0 = _slicedToArray(_ref9, 2),
      entryKey = _ref0[0],
      attributeKey = _ref0[1];
    var entryVal = entry[entryKey];
    if (entryVal != null && (typeof entryVal === 'number' && entryVal < MAX_INT_AS_BYTES || typeof entryVal === 'string')) {
      attributes[attributeKey] = entryVal;
    }
  });
}

/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */
function _addTtfbRequestTimeToMeasurements(_measurements) {
  var navEntry = getNavigationEntry(false);
  if (!navEntry) {
    return;
  }
  var responseStart = navEntry.responseStart,
    requestStart = navEntry.requestStart;
  if (requestStart <= responseStart) {
    _measurements['ttfb.requestTime'] = {
      value: responseStart - requestStart,
      unit: 'millisecond'
    };
  }
}
export { _addMeasureSpans, _addNavigationSpans, _addResourceSpans, _setResourceRequestAttributes, addPerformanceEntries, startTrackingInteractions, startTrackingLongAnimationFrames, startTrackingLongTasks, startTrackingWebVitals };